namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{
			export class Property extends SPA.Guide.GuideContent
			{

				private m_Form: ui.Form.Form;

				public constructor(private m_Data: INewDisposalObject, private m_Obj: Realtor2.NewObject )
				{
					super();

					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => { return; }
						}
					);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					this.m_Form.empty();
					this.m_Form.remove();
					this.m_Form.clear();

					this.m_Form.rebuild( root );

					const rowlh		= new ui.base.BaseHTMLElement( 'div' ).addClass( 'row' );
					const rowinv	= new ui.base.BaseHTMLElement( 'div' ).addClass( 'row' );

					{
						const row = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'row' )
						.appendTo( this.m_Form );

						// #region Gründstücksflächen
						this.buildPropertyAreas(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-6' )
								.append(
									new ui.base.BaseHTMLElement( 'h4' )
										.text( 'Grundstücksflächen' )
									.addClass( 'text-muted' )
								)
							.appendTo( row )
						);
						// #endregion Grundstücksflächen

						// Lagequalität aus 01_Common
						this.buildQualityArea(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-12 col-md-6')
								.append(
									new ui.base.BaseHTMLElement('h4')
										.text('Lagequalität')
										.addClass('text-muted')
								)
								.appendTo(row)
						);

						this.m_Form.append(ui.$$.hr());
					}

					{
						// Zuschnitt_Zuweg_(Garten/Hof/Einfriedung)_Bewertung
						const row = new ui.base.BaseHTMLElement('div')
							.addClass('row')
							.appendTo(this.m_Form);

						// #region Zuschnitt_Zuweg_(Garten/Hof/Einfriedung)_Bewertung
						this.buildStructuralData(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-12')
								.append(
									new ui.base.BaseHTMLElement('h4')
										.text('Zugang / Außenanlagen')
										.addClass('text-muted')
								)
								.appendTo(row)
						);

						this.m_Form.append(ui.$$.hr());
					}

					rowlh.appendTo( this.m_Form );
					rowinv.appendTo( this.m_Form );

					// #region Erbbaurecht
					// this.buildLeasehold( rowlh );
					// #endregion Erbbaurecht

					// #region Bestandsverzeichnis
					// this.buildRegister( rowinv );
					// this.m_Form.append( ui.$$.hr() );
					// #endregion Bestandsverzeichnis

					// #region Baulasten
					// this.buildBaulasten( new ui.base.BaseHTMLElement( 'div' ).addClass( 'row' ).appendTo( this.m_Form ) );
					// this.m_Form.append( ui.$$.hr() );
					// #endregion Baulasten

					// #region Lasten_und_Beschränkungen_Abteilung2
					// this.buildLUB( new ui.base.BaseHTMLElement( 'div' ).addClass( 'row' ).appendTo( this.m_Form ) );
					// this.m_Form.append( ui.$$.hr() );
					// #endregion Lasten_und_Beschränkungen_Abteilung2

					// #region Bemerkung
					this.buildPropertyAnnotation(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'row' )
						.appendTo( this.m_Form )
					);
					// #endregion bemerkung
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel ) { this.m_Panel.MovePrev(); }
								}
							}
						}
					).rebuild( nav );

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel )
									{
										if ( this.m_Obj.checkForm( this.m_Form ) )
										{
											this.m_Panel.MoveNext();
										}
									}
								}
							}
						}
					).rebuild( nav );
				}

				private buildPropertyAreas( _root: ui.base.BaseHTMLElement, _lhRoot: ui.base.BaseHTMLElement ): void
				{
					const area = new ui.base.BaseHTMLElement( 'p' )
						.addClass( 'form-control-static' )
					.text( ( this.m_Data ? accounting.formatNumber(this.m_Data.property.area.building + this.m_Data.property.area.garden) : '' ) + " m²" );
					const hginput = new ui.Form.TextInput(
						this.m_Data && this.m_Data.property.area.garden ? accounting.formatNumber(this.m_Data.property.area.garden) : null,
						{
							classes: ['number', 'iwv-req'],
							name: 'property.area.garden',
							control: true,
							on: {
								keyup: () =>
								{
									const g = accounting.unformat(hginput.val() || "0");
									const b = this.m_Data.property.area.building;

									this.m_Data.property.area.garden = accounting.unformat(g.toString(), ',');
									area.text(accounting.formatNumber( g + b ) + " m²" );
								},
								change: () =>
								{
									const g = accounting.unformat(hginput.val() || "0");
									const b = this.m_Data.property.area.building;

									this.m_Data.property.area.garden = accounting.unformat(g.toString(), ',');
									area.text( accounting.formatNumber( g + b ) + " m²" );
								}
							}
						}
					);
					const bfinput = new ui.Form.TextInput(
						this.m_Data && this.m_Data.property.area.building ? accounting.formatNumber(this.m_Data.property.area.building) : null,
						{
							classes: ['number iwv-req'],
							name: 'property.area.building',
							required: true,
							control: true,
							on: {
								keyup: () =>
								{
									const g = this.m_Data.property.area.garden || 0;
									const b = accounting.unformat(bfinput.val() || "0");

									this.m_Data.property.area.building = b;
									area.text(accounting.formatNumber( g + b ) + " m²" );
								},
								change: () =>
								{
									const g = this.m_Data.property.area.garden || 0;
									const b = accounting.unformat(bfinput.val() || "0");

									this.m_Data.property.area.building = b;
									area.text(accounting.formatNumber( g + b ) + " m²" );

								}
							}
						}
					);

					// # bebaubare Fläche
					let ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
									.addClass( 'control-label col-xs-12 col-md-3' )
									.text( 'Bebaubare Fläche*' )
								)
							.appendTo( _root )
						)
					);

					this.addToForm( ig, this.m_Form, bfinput );

					new ui.base.BaseHTMLElement( 'span' )
						.addClass( 'input-group-addon' )
						.text( 'm²' )
					.appendTo( ig );

					// # Garten-/Hinterland
					ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-7' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
									.addClass( 'control-label col-xs-12 col-md-5' )
									.text( 'Garten-/Hinterland' )
								)
							.appendTo( _root )
						)
					);

					this.addToForm( ig, this.m_Form, hginput );

					new ui.base.BaseHTMLElement( 'span' )
						.addClass( 'input-group-addon' )
						.text( 'm²' )
					.appendTo( ig );

					// # Grundstücksfläche
					new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'col-xs-12 col-md-9' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'form-group clearfix' )
							.append(
								new ui.base.BaseHTMLElement( 'label' )
									.addClass( 'control-label col-xs-12' )
								.text( 'Grundstücksfläche' )
							)
							.append(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-12' )
								.append( area )
							)
						.appendTo( _root )
					);

					// Leasehold option deactivated for now
					// const lh_input = new ui.Form.Checkbox(
					// 	{
					// 		title: 'Erbbaurecht vorhanden',
					// 		descriptor:
					// 		{
					// 			on:
					// 			{
					// 				change: () =>
					// 				{
					// 					this.m_Data.property.leasehold.present = lh_input.val();
					//
					// 					this.buildLeasehold( _lhRoot );
					// 				}
					// 			}
					// 		}
					// 	}
					// );
					//
					// // # Erbbaurecht vorhanden
					// this.addToForm(
					// 	new ui.base.BaseHTMLElement( 'div' )
					// 		.addClass( 'col-xs-12 checkbox' )
					// 	.appendTo(
					// 		new ui.base.BaseHTMLElement( 'div' )
					// 			.addClass( 'form-group clearfix' )
					// 		.appendTo( _root )
					// 	),
					// 	this.m_Form,
					// 	lh_input
					// );
				}

				private buildQualityArea(_root: ui.base.BaseHTMLElement): void
				{
					const lq = _root;

					new ui.base.BaseHTMLElement('label')
						.addClass('control-label col-xs-12 col-md-3')
						.text('Mikrolage:')
						.appendTo(lq);

					const microLNS = new ui.Form.LabelledNumberSlider(
						this.m_Data ? this.m_Data.object.quality.micro : -1,
						{
							min: 0,
							max: 4,
							step: 1,
							sentinal: 'Bitte wählen ...',
							name: 'object.quality.micro',
							control: true,
							on: {
								change: () => this.m_Data.object.quality.micro = microLNS.val()
							}
						},
						(n: number) => {
							const list = ['Mangelhaft', 'Ausreichend', 'Befriedigend', 'Gut', 'Sehr gut'];

							return list[n];
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-9')
							.appendTo(lq),
						this.m_Form,
						microLNS
					);

					new ui.base.BaseHTMLElement('label')
						.addClass('control-label col-xs-12 col-md-3')
						.text('Makrolage:')
						.appendTo(lq);

					const macroLNS = new ui.Form.LabelledNumberSlider(
						this.m_Data ? this.m_Data.object.quality.macro : -1,
						{
							min: 0,
							max: 4,
							step: 1,
							sentinal: 'Bitte wählen ...',
							name: 'object.quality.macro',
							control: true,
							on: {
								change: () => this.m_Data.object.quality.macro = macroLNS.val()
							}
						},
						(n: number) => {
							const list = ['Mangelhaft', 'Ausreichend', 'Befriedigend', 'Gut', 'Sehr gut'];

							return list[n];
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-9')
							.appendTo(lq),
						this.m_Form,
						macroLNS
					);

					new ui.base.BaseHTMLElement('label')
						.addClass('control-label col-xs-12 col-md-3')
						.text('Bemerkung zur Lagequalität:')
						.appendTo(lq);

					const annTextarea: ui.Form.TextArea = new ui.Form.TextArea({
						name: 'object.quality.annotation',
						control: true,
						required: false,
						rows: 5,
						text: this.m_Data ? this.m_Data.object.quality.annotation : undefined,
						on: {
							change: () => this.m_Data.object.quality.annotation = annTextarea.val().trim()
						}
					}).value(this.m_Data && this.m_Data.object ? this.m_Data.object.quality.annotation : null);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-9')
							.appendTo(lq),
						this.m_Form,
						annTextarea
					);
				}

				private buildStructuralData( _root: ui.base.BaseHTMLElement ): void
				{
					const row = ui.$$.div().addClass('row');
					const col1 = ui.$$.div().addClass('col-xs-12 col-md-6');
					const col2 = ui.$$.div().addClass('col-xs-12 col-md-6');

					_root.append(col1);
					_root.append(col2);

					const path_ = new ui.Form.RadioGroup(
						{
							value: this.m_Data ? this.m_Data.property.structural.path : undefined,
							name: 'property.structural.path',
							// required: true,
							control: true,
							inline: 2,
							radioButtons:
							[
								{
									value: 'public',
									title: 'Öffentlich'
								},
								{
									value: 'private',
									title: 'Privat'
								}
							],
							on:
							{
								change: () =>
								{
									this.m_Data.property.structural.path = path_.val();
								}
							}
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Zuwegung' )
									.addClass( 'control-label col-xs-12' )
								)
							.appendTo(col1 )
						),
						this.m_Form,
						path_
					);

					const cut_ = new ui.Form.RadioGroup(
						{
							value: this.m_Data ? this.m_Data.property.structural.layout.value : undefined,
							name: 'property.structural.layout.value',
							// required: true,
							control: true,
							inline: 2,
							radioButtons:
							[
								{
									value: 'good',
									title: 'Gut'
								},
								{
									value: 'bad',
									title: 'Ungünstig'
								}
							],
							on:
							{
								change: () =>
								{
									this.m_Data.property.structural.layout.value = cut_.val();
								}
							}
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Zuschnitt' )
									.addClass( 'control-label col-xs-12' )
								)
							.appendTo(col1 )
						),
						this.m_Form,
						cut_
					);

					const chckbxs = new ui.Form.CheckboxGroup(
						{
							inline: 4,
							control: true,
							name: 'property.structural.layout',
							checkboxes:
							[
								{
									title: 'Handtuch',
									name: 'towel',
									descriptor: {
										on: { change: () => this.m_Data.property.structural.layout.towel = !this.m_Data.property.structural.layout.towel }
									}
								},
								{
									title: 'Pfeife',
									name: 'pipe',
									descriptor: {
										on: {change: () => this.m_Data.property.structural.layout.pipe = !this.m_Data.property.structural.layout.pipe}
									}
								},
								{
									title: 'Eckgrundstück',
									name: 'corner',
									descriptor: {
										on: {change: () => this.m_Data.property.structural.layout.corner = !this.m_Data.property.structural.layout.corner}
									}
								},
								{
									title: 'Hanglage',
									name: 'slope',
									descriptor: {
										on: {change: () => this.m_Data.property.structural.layout.slope = !this.m_Data.property.structural.layout.slope}
									}
								}
							],
							value:
							[
								this.m_Data.property && this.m_Data.property.structural.layout.towel ? 'property.structural.layout.towel' : '',
								this.m_Data.property && this.m_Data.property.structural.layout.pipe ? 'property.structural.layout.pipe' : '',
								this.m_Data.property && this.m_Data.property.structural.layout.corner ? 'property.structural.layout.corner' : '',
								this.m_Data.property && this.m_Data.property.structural.layout.slope ? 'property.structural.layout.slope' : '',
							]
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
							.appendTo(col1 )
						),
						this.m_Form,
						chckbxs
					);

					const ls_garden = new ui.Form.LabelledSlider(
						{
							name: 'property.structural.garden',
							value: [ 'wip', 'ez', 'avg', 'costly' ],
							sentinal: 'Keine Auswahl',
							control: true,
							required: true,
							on:
							{
								change: () =>
								{
									const val = ls_garden.val();

									if ( val === null || val < 0 )
									{
										this.m_Data.property.structural.garden = null;
									}
									else if ( val >= 0 && val < 4 )
									{
										this.m_Data.property.structural.garden = [ 'wip', 'ez', 'avg', 'costly' ][ val ];
									}
								}
							}
						},
						( text: string ) =>
						{
							let val = 'Keine Auswahl';

							switch ( text )
							{
								case 'wip':			val = 'In Arbeit';				break;
								case 'ez':			val = 'Einfach';					break;
								case 'avg':			val = 'Durchschnittlich';	break;
								case 'costly':	val = 'Aufwändig';				break;
							}

							return val;
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Garten' )
									.addClass( 'control-label col-xs-3' )
								)
							.appendTo(col2)
						),
						this.m_Form,
						ls_garden
					);
					ls_garden.value(this.m_Data && this.m_Data.property && this.m_Data.property.structural.garden ? ['wip', 'ez', 'avg', 'costly'].indexOf(this.m_Data.property.structural.garden) : -1);

					const ls_court = new ui.Form.LabelledSlider(
						{
							name: 'property.structural.courtyard',
							value: [ 'wip', 'ez', 'avg', 'costly' ],
							sentinal: 'Keine Auswahl',
							control: true,
							required: true,
							on:
							{
								change: () =>
								{
									const val = ls_court.val();

									if ( val === null || val < 0 )
									{
										this.m_Data.property.structural.courtyard = null;
									}
									else if ( val >= 0 && val < 4 )
									{
										this.m_Data.property.structural.courtyard = [ 'wip', 'ez', 'avg', 'costly' ][ val ];
									}
								}
							}
						},
						( text: string ) =>
						{
							let val = 'Keine Auswahl';

							switch ( text )
							{
								case 'wip':			val = 'In Arbeit';				break;
								case 'ez':			val = 'Einfach';					break;
								case 'avg':			val = 'Durchschnittlich';	break;
								case 'costly':	val = 'Aufwändig';				break;
							}

							return val;
						}
					).value(
						this.m_Data.property && this.m_Data.property.structural.courtyard !== null ?
						(
							this.m_Data.property.structural.courtyard !== 'costly' ?
							(
								this.m_Data.property.structural.courtyard !== 'avg' ?
								(
									this.m_Data.property.structural.courtyard !== 'ez' ? 0 : 1
								) :
								2
							) :
							3
						) :
						-1
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Hof' )
									.addClass( 'control-label col-xs-3' )
								)
							.appendTo(col2)
						),
						this.m_Form,
						ls_court
					);
					ls_court.value(this.m_Data && this.m_Data.property && this.m_Data.property.structural.courtyard ? ['wip', 'ez', 'avg', 'costly'].indexOf(this.m_Data.property.structural.courtyard) : -1);

					const encl_values = ['wip', 'ez', 'avg', 'costly'];

					const ls_encl = new ui.Form.LabelledSlider(
						{
							name: 'property.structural.enclosure',
							value: encl_values,
							sentinal: 'Keine Auswahl',
							control: true,
							required: true,
							on:
							{
								change: () =>
								{
									const val = ls_encl.val();

									if ( val === null || val < 0 )
									{
										this.m_Data.property.structural.enclosure = null;
									}
									else if ( val >= 0 && val < 4 )
									{
										this.m_Data.property.structural.enclosure = encl_values[ val ];
									}
								}
							}
						},
						( text: string ) =>
						{
							let val = 'Keine Auswahl';

							switch ( text )
							{
								case 'wip':			val = 'In Arbeit';				break;
								case 'ez':			val = 'Einfach';					break;
								case 'avg':			val = 'Durchschnittlich';	break;
								case 'costly':	val = 'Aufwändig';				break;
							}

							return val;
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Einfriedung' )
									.addClass( 'control-label col-xs-3' )
								)
							.appendTo(col2)
						),
						this.m_Form,
						ls_encl
					);
					ls_encl.value(this.m_Data && this.m_Data.property && this.m_Data.property.structural.enclosure ? ['wip', 'ez', 'avg', 'costly'].indexOf(this.m_Data.property.structural.enclosure) : -1);
				}

				private buildPropertyAnnotation( _root: ui.base.BaseHTMLElement ): void
				{
					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
							.append($('<h4 class="text-muted">Bemerkungen zum Grundstück</h4>'))
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
							.appendTo( _root )
						),
						this.m_Form,
						new ui.Form.TextArea(
							{
								control: true,
								rows: 5,
								attr:
								{
									style: 'resize: vertical;'
								},
								name: 'property.annotation'
							}
						)
					);
				}

				private buildLeasehold( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					if ( this.m_Data.property && this.m_Data.property.leasehold.present )
					{
						_root.remClass( 'hidden' );
					}
					else
					{
						_root.addClass( 'hidden' );
					}

					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Erbbaurecht' )
					.appendTo( _root );

					let row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( _root );

					// #region Restlaufzeit
					let ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Restlaufzeit*' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo( row )
						)
					);

					const ig_i = new ui.Form.NumberInput(
						this.m_Data.property ? this.m_Data.property.leasehold.residual_time : null,
						{
							name: 'property.leasehold.residual_time',
							control: true,
							min: 0,
							step: 1,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.residual_time = ig_i.val() || 0;
								}
							}
						}
					);

					this.addToForm( ig, this.m_Form, ig_i );

					ig.append(
						new ui.base.BaseHTMLElement( 'span' )
							.text( 'Jahre' )
						.addClass( 'input-group-addon' )
					);
					// #endregion Restlaufzeit

					// #region Erbbauzins
					ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Erbbauzins*' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo( row )
						)
					);

					const ig_rate = new ui.Form.NumberInput(
						this.m_Data.property ? this.m_Data.property.leasehold.ground_rent : null,
						{
							name: 'property.leasehold.ground_rent',
							control: true,
							min: 0,
							step: 1,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.ground_rent = ig_rate.val() || 0;
								}
							}
						}
					);

					this.addToForm( ig, this.m_Form, ig_rate );

					ig.append(
						new ui.base.BaseHTMLElement( 'span' )
							.text( '€ p.a.' )
						.addClass( 'input-group-addon' )
					);
					//#endregion Erbbauzins

					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( _root );

					// #region Gebäudeentschädigung
					ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Gebäudeentschädigung*' )
									.addClass( 'control-label col-xs-12 col-md-6' )
								)
							.appendTo( row )
						)
					);

					const ig_comp = new ui.Form.NumberInput(
						this.m_Data.property ? this.m_Data.property.leasehold.compensation : null,
						{
							name: 'property.leasehold.compensation',
							control: true,
							min: 0,
							step: 1,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.compensation = ig_comp.val() || 0;
								}
							}
						}
					);

					this.addToForm( ig, this.m_Form, ig_comp );

					ig.append(
						new ui.base.BaseHTMLElement( 'span' )
							.text( '%' )
						.addClass( 'input-group-addon' )
					);
					// #endregion Gebäudeentschädigung

					// #region Nachteile
					ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( '"Allgemeinere Nachteile" pauschaler Abschlag*' )
									.addClass( 'control-label col-xs-12 col-md-6' )
								)
							.appendTo( row )
						)
					);

					const ig_dis = new ui.Form.NumberInput(
						this.m_Data.property ? this.m_Data.property.leasehold.disadvantage : null,
						{
							name: 'property.leasehold.disadvantage',
							control: true,
							min: 0,
							step: 0.1,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.disadvantage = ig_dis.val() || 0;
								}
							}
						}
					);

					this.addToForm( ig, this.m_Form, ig_dis );

					ig.append(
						new ui.base.BaseHTMLElement( 'span' )
							.text( '%' )
						.addClass( 'input-group-addon' )
					);
					//#endregion Nachteile

					new ui.base.BaseHTMLElement( 'p' )
						.addClass( 'text-muted' )
						.text(
							'Die Höhe der Gebäudeentschädigung muss regelmäßig ' +
							'2/3 des gemeinen Wertes bei Zeitablauf betragen.'
						)
					.appendTo( _root );

					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( _root );

					// #region Zinssatz
					ig = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Zinssatz* (max 5%)' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo( row )
						)
					);

					const ig__rate = new ui.Form.NumberInput(
						this.m_Data.property ? this.m_Data.property.leasehold.rate : null,
						{
							name: 'property.leasehold.rate',
							control: true,
							min: 0,
							step: 0.01,
							max: 5,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.rate = ig__rate.val() || 0;
								}
							}
						}
					);

					this.addToForm( ig, this.m_Form, ig__rate );

					ig.append(
						new ui.base.BaseHTMLElement( 'span' )
							.text( '%' )
						.addClass( 'input-group-addon' )
					);
					// #endregion Zinssatz

					// #region Bemerkung
					const ig_ann = new ui.Form.TextArea(
						{
							name: 'property.leasehold.annotation',
							attr:
							{
								style: 'resize: vertical;'
							},
							rows: 3,
							text: this.m_Data.property ? this.m_Data.property.leasehold.annotation : undefined,
							on:
							{
								change: () =>
								{
									this.m_Data.property.leasehold.annotation = ig_ann.val() || '';
								}
							}
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-6' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Bemerkung zum Erbbaurecht' )
									.addClass( 'control-label col-xs-12' )
								)
							.appendTo( row )
						),
						this.m_Form,
						ig_ann
					);
					//#endregion Bemerkung

					_root.append(
						ui.$$.div().addClass( 'form-group clearfix' ).append(
							ui.$$.div().addClass('col-xs-12' ).append( ui.$$.hr() )
						)
					);
				}

				private buildRegister( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Bestandsverzeichnis' )
					.appendTo( _root );

					let row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					// #region row1
					{
						const l = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo( row );

						const r = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo( row );

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-9' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
									.append(
										new ui.base.BaseHTMLElement( 'label' )
											.text( 'Grundbuch von' )
										.addClass( 'control-label col-xs-12 col-md-3' )
									)
								.appendTo( l )
							),
							this.m_Form,
							new ui.Form.TextInput(
								this.m_Data.property ? this.m_Data.property.register.registry_deeds : null,
								{
									name: 'property.register.registry_deeds',
									control: true
								}
							)
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-9' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
									.append(
										new ui.base.BaseHTMLElement( 'label' )
											.text( 'Band' )
										.addClass( 'control-label col-xs-12 col-md-3' )
									)
								.appendTo( l )
							),
							this.m_Form,
							new ui.Form.TextInput(
								this.m_Data.property ? this.m_Data.property.register.volume : null,
								{
									name: 'property.register.volume',
									control: true
								}
							)
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-9' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
									.append(
										new ui.base.BaseHTMLElement( 'label' )
											.text( 'Amtsgericht' )
										.addClass( 'control-label col-xs-12 col-md-3' )
									)
								.appendTo( r )
							),
							this.m_Form,
							new ui.Form.TextInput(
								this.m_Data.property ? this.m_Data.property.register.court : null,
								{
									name: 'property.register.court',
									control: true
								}
							)
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-9' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
									.append(
										new ui.base.BaseHTMLElement( 'label' )
											.text( 'Blatt / Heft' )
										.addClass( 'control-label col-xs-12 col-md-3' )
									)
								.appendTo( r )
							),
							this.m_Form,
							new ui.Form.TextInput(
								this.m_Data.property ? this.m_Data.property.register.page : null,
								{
									name: 'property.register.page',
									control: true
								}
							)
						);
					}
					// #endregion row1

					// #region row2
					{
						const btn_bar = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
							.css(
								{
									'display': 'flex',
									'justify-content': 'space-evenly'
								}
							)
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'row' )
							.appendTo( _root )
						);
						new ui.base.Button(
							ui.$$.span()
								.append( ui.$$.span().addClass( 'fa fa-plus fa-lg' ) )
								.append( ui.$$.text( ' Neues Flurstück anlegen' ) ),
							{
								context: 'primary',
								size: 'sm',
								attr:
								{
									type: 'button'
								},
								on: {
									click: () =>
									{
										this.m_Data.property.register.list.push(
											{
												no: null,
												gemarkung: null,
												flur: null,
												flurstueck: null,
												area: null,
												fraction: null,
												buildable: false,
												GFZ: null
											}
										);

										this.buildRegister( _root );
									}
								}
							}
						).rebuild( btn_bar );

						new ui.base.Button(
							ui.$$.span()
								.append( ui.$$.span().addClass( 'fa fa-trash fa-lg' ) )
								.append( ui.$$.text( ' Alle Flurstück löschen' ) ),
							{
								context: 'danger',
								size: 'sm',
								classes: [ 'pull-right' ],
								attr:
								{
									type: 'button'
								},
								on: {
									click: () =>
									{
										this.m_Data.property.register.list = [];

										this.buildRegister( _root );
									}
								}
							}
						).rebuild( btn_bar );

						const ul = new ui.base.BaseHTMLElement( 'ul' )
							.addClass( 'list-group' )
							.css(
								{
									'margin-top': '20px',
									'margin-left': '50px',
									'margin-right': '50px'
								}
							)
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'row' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-12' )
								.appendTo( _root )
							 )
						);

						if (this.m_Data.property)
						{
							this.m_Data.property.register.list.forEach(
								( inv, idx ) =>
								{
									const litem = new ui.base.BaseHTMLElement( 'li' )
										.addClass( 'list-group-item row' )
									.appendTo( ul );

									{ // # delete button
										const dlbtn = new ui.base.Button(
											undefined,
											{
												context: 'danger',
												size: 'xs',
												classes: [ 'pull-right' ],
												attr:
												{
													type: 'button'
												},
												on:
												{
													click: () =>
													{
														this.m_Data.property.register.list = this.m_Data.property.register.list.filter( (v, i) => i !== idx );
														this.buildRegister( _root );
													}
												}
											}
										).rebuild( litem );
										new ui.base.BaseHTMLElement( 'span' )
											.addClass( 'fa fa-trash' )
										.appendTo( dlbtn );
									}

									let _row_ = new ui.base.BaseHTMLElement( 'div' )
										.addClass( 'form-group clearfix' )
									.appendTo(
										new ui.base.BaseHTMLElement( 'div' )
											.addClass( 'col-xs-12' )
										.appendTo( litem )
									);

									{ // # row 1
										const lfdnr = new ui.Form.NumberInput(
											inv.no !== null ? Number( inv.no ) : null,
											{
												on:
												{
													change: () =>
													{
														inv.no = String( lfdnr.val() || '' );
													}
												},
												control: true,
												min: 0,
												step: 1,
												noautocomplete: true,
												required: false
											}
										);

										const mark: ui.Form.TextInput = new ui.Form.TextInput(
											inv.gemarkung,
											{
												on:
												{
													change: () => inv.gemarkung = mark.val()
												},
												control: true,
												noautocomplete: true,
												required: false
											}
										);

										const flur: ui.Form.TextInput = new ui.Form.TextInput(
											inv.flur,
											{
												on:
												{
													change: () => inv.flur = flur.val()
												},
												control: true,
												noautocomplete: true,
												required: false
											}
										);

										const flurstk: ui.Form.TextInput = new ui.Form.TextInput(
											inv.flurstueck,
											{
												on:
												{
													change: () => inv.flurstueck = flurstk.val()
												},
												control: true,
												noautocomplete: true,
												required: false
											}
										);

										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Lfd.Nr.' )
													.addClass( 'col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											lfdnr
											);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Gemarkung' )
													.addClass( 'col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											mark
											);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Flur' )
													.addClass( 'col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											flur
											);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Flurstück' )
													.addClass( 'col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											flurstk
										);
									}

									_row_ = new ui.base.BaseHTMLElement( 'div' )
										.addClass( 'form-group clearfix' )
									.appendTo(
										new ui.base.BaseHTMLElement( 'div' )
											.addClass( 'col-xs-12' )
										.appendTo( litem )
									);
									{ // # row 2
										const size: ui.Form.NumberInput = new ui.Form.NumberInput(
											inv.area,
											{
												noautocomplete: false,
												on:
												{
													change: () =>
													{
														inv.area = size.val();
													}
												}
											}
										);
										const fraction: ui.Form.NumberInput = new ui.Form.NumberInput(
											inv.fraction || null,
											{
												noautocomplete: false,
												on:
												{
													change: () =>
													{
														inv.fraction = fraction.val();
													}
												},
												min: 0,
												max: 100,
												step: 1
											}
										);
										const usable: ui.Form.Checkbox = new ui.Form.Checkbox(
											{
												title: 'bebaubare Fläche'
											}
										);
										usable.value( inv.buildable );
										const gfz: ui.Form.TextInput = new ui.Form.TextInput(
											inv.GFZ || null,
											{
												noautocomplete: false,
												on:
												{
													change: () =>
													{
														inv.GFZ = gfz.val();
													}
												}
											}
										);

										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Größe' )
													.addClass( 'control-label col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											size
										);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'Bruchteil' )
													.addClass( 'control-label col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											fraction
										);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-11 col-xs-offset-1 col-md-2 col-md-offset-1' )
											.appendTo( _row_ ),
											this.m_Form,
											usable
										);
										this.addToForm(
											new ui.base.BaseHTMLElement( 'div' )
												.addClass( 'col-xs-8 col-md-2' )
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement( 'label' )
														.text( 'GFZ' )
													.addClass( 'control-label col-xs-4 col-md-1' )
												)
											),
											this.m_Form,
											gfz
										);
									}
								}
							);
						}
					}
					// #endregion row2

					// #region row3
					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Aktivvermerk für Flurstück' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-12 col-md-6' )
								.appendTo( row )
							)
						),
						this.m_Form,
						new ui.Form.TextInput(
							this.m_Data.property ? this.m_Data.property.register.active_annotation : null,
							{
								name: 'property.register.active_annotation',
								control: true
							}
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-9' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Vermerk' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-12 col-md-6' )
								.appendTo( row )
							)
						),
						this.m_Form,
						new ui.Form.TextInput(
							this.m_Data.property ? this.m_Data.property.register.annotation : null,
							{
								name: 'property.register.annotation',
								control: true
							}
						)
					);
					// #endregion row3
				}

				private buildBaulasten( _root: ui.base.BaseHTMLElement ): void
				{
					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Baulasten' )
					.appendTo( _root );

					const row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'form-group clearfix' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-5 col-md-3' )
							.appendTo( row )
						),
						this.m_Form,
						new ui.Form.Select(
							{
								name: 'property.easements.value',
								control: true,
								option:
								{
									NOTHING: 'Keine Baulasten',
									NEED_INSPECTION: 'Baulastenverzeichnis einsehen',
									ABANDON_INSPECTION: 'Verzicht auf Einsichtnahme'
								}
							},
							this.m_Data.property ? this.m_Data.property.easements.value : undefined
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'form-group clearfix' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-7 col-md-9' )
							.appendTo( row )
						),
						this.m_Form,
						new ui.Form.TextArea(
							{
								name: 'property.easements.annotation',
								control: true,
								text: this.m_Data.property ? this.m_Data.property.easements.annotation : undefined,
								attr:
								{
									style: 'resize: vertical'
								}
							}
						)
					);
				}

				private buildLUB( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Abteilung II - Lasten und Beschränkungen' )
					.appendTo( _root );

					{ // # 'add' & 'remove all' buttons
						const btn_bar = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
							.css(
								{
									'display': 'flex',
									'justify-content': 'space-evenly'
								}
							)
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'row' )
							.appendTo( _root )
						);
						new ui.base.Button(
							ui.$$.span()
								.append( ui.$$.span().addClass( 'fa fa-plus fa-lg' ) )
								.append( ui.$$.text( ' Neue Vorlast anlegen' ) ),
							{
								context: 'primary',
								size: 'sm',
								attr:
								{
									type: 'button'
								},
								on: {
									click: () =>
									{
										this.m_Data.property.preload.push(
											{
												no: null,
												type: null,
												definition: '',
												value_approach: null,
												value: null,
												period: null,
												runtime:
												{
													type: null,
													value: null
												},
												rate: null
											}
										);

										this.buildLUB( _root );
									}
								}
							}
						).rebuild( btn_bar );

						new ui.base.Button(
							ui.$$.span()
								.append( ui.$$.span().addClass( 'fa fa-trash fa-lg' ) )
								.append( ui.$$.text( ' Alle Vorlasten löschen' ) ),
							{
								context: 'danger',
								size: 'sm',
								classes: [ 'pull-right' ],
								attr:
								{
									type: 'button'
								},
								on: {
									click: () =>
									{
										this.m_Data.property.preload = [];

										this.buildLUB( _root );
									}
								}
							}
						).rebuild( btn_bar );
					}

					const ul = new ui.base.BaseHTMLElement( 'ul' )
						.addClass( 'list-group' )
						.css(
							{
								'margin-top': '20px',
								'margin-left': '50px',
								'margin-right': '50px'
							}
						)
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'row' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12' )
							.appendTo( _root )
						)
					);

					if (this.m_Data.propert) {
						this.m_Data.property.preload.forEach(
							(pl, idx) => {
								const litem = new ui.base.BaseHTMLElement('li')
									.addClass('list-group-item row')
									.appendTo(ul);

								{ // # delete button
									const dlbtn = new ui.base.Button(
										undefined,
										{
											context: 'danger',
											size: 'xs',
											classes: ['pull-right'],
											attr:
												{
													type: 'button'
												},
											on:
												{
													click: () => {
														this.m_Data.property.preload = this.m_Data.property.preload.filter((v, i) => i !== idx);
														this.buildLUB(_root);
													}
												}
										}
									).rebuild(litem);
									new ui.base.BaseHTMLElement('span')
										.addClass('fa fa-trash')
										.appendTo(dlbtn);
								}

								let _row_ = new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-12')
											.appendTo(litem)
									);

								{ // # row 1
									const lfdnr: ui.Form.TextInput = new ui.Form.TextInput(
										pl.no,
										{
											noautocomplete: false,
											control: true,
											on:
												{
													change: () => pl.no = lfdnr.val()
												}
										}
									);
									const _type: ui.Form.Select = new ui.Form.Select(
										{
											control: true,
											on:
												{
													change: () => pl.type = _type.val()
												},
											option:
												{
													LOAD: 'Vorlast',
													CONSTRAINT: 'Beschränkung'
												}
										},
										pl.type || undefined
									);
									const def: ui.Form.TextInput = new ui.Form.TextInput(
										pl.definition,
										{
											noautocomplete: false,
											control: true,
											on:
												{
													change: () => pl.definition = (def.val() || '')
												}
										}
									);
									const va: ui.Form.NumberInput = new ui.Form.NumberInput(
										pl.value_approach,
										{
											noautocomplete: false,
											control: true,
											on:
												{
													change: () => pl.value_approach = va.val()
												}
										}
									);

									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Lfd.Nr.')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										lfdnr
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Art')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										_type
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Erläuterung')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										def
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Wertansatz')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										va
									);
								}

								_row_ = new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-12')
											.appendTo(litem)
									);

								{ // # row 2
									new ui.base.BaseHTMLElement('h4')
										.addClass('text-muted')
										.text('Kapitalisierung')
										.appendTo(_row_);

									const val: ui.Form.NumberInput = new ui.Form.NumberInput(
										pl.value,
										{
											control: true,
											min: 0,
											step: 0.01,
											on:
												{
													change: () => pl.value = val.val()
												}
										}
									);

									const per: ui.Form.Select = new ui.Form.Select(
										{
											control: true,
											on:
												{
													change: () => pl.period = per.val()
												},
											blank: 'Bitte wählen ...',
											option:
												{
													MONTHLY: 'monatlich',
													YEARLY: 'jährlich'
												}
										},
										pl.period || undefined
									);

									const run_val: ui.Form.NumberInput = new ui.Form.NumberInput(
										pl.runtime.value,
										{
											control: true,
											on:
												{
													change: () => pl.runtime.value = run_val.val()
												}
										}
									);

									const run_per: ui.Form.Select = new ui.Form.Select(
										{
											control: true,
											on:
												{
													change: () => pl.runtime.type = run_per.val()
												},
											blank: 'Bitte wählen ...',
											option:
												{
													MONTHLY: 'monatlich',
													YEARLY: 'jährlich',
													INF: 'endlos'
												}
										},
										pl.runtime.type || undefined
									);

									const rate: ui.Form.NumberInput = new ui.Form.NumberInput(
										pl.rate,
										{
											control: true,
											on:
												{
													change: () => pl.rate = rate.val()
												}
										}
									);

									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Betrag')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										val
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-1')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Zahlungsperiode')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										per
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-5 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Laufzeit')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										run_val
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-3 col-md-1')
											.appendTo(_row_),
										this.m_Form,
										run_per
									);
									this.addToForm(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-8 col-md-2')
											.appendTo(
												_row_.append(
													new ui.base.BaseHTMLElement('label')
														.text('Zinssatz')
														.addClass('control-label col-xs-4 col-md-1')
												)
											),
										this.m_Form,
										rate
									);
								}
							}
						);
					}
				}
			}
		}
	}
}
